import { CategoryDetailsComponent } from './category/category-details/category-details.component';
import { CategoryCreateComponent } from './category/category-create/category-create.component';
import { ContentDetailsComponent } from './content/content-details/content-details.component';
import { CategoryListComponent } from './category/category-list/category-list.component';
import { AddElearningComponent } from './content/add-elearning/add-elearning.component';
import { TopicDetailsComponent } from './topic/topic-details/topic-details.component';
import { ContentListComponent } from './content/content-list/content-list.component';
import { FasServicesUploadComponent, FasServiceTableComponent } from 'fas-services';
import { TopicCreateComponent } from './topic/topic-create/topic-create.component';
import { TopicListComponent } from './topic/topic-list/topic-list.component';
import { OverviewListComponent } from './overview/overview-list/overview-list.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ElearningComponent } from './elearning.component';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

// PrimeNG
import { DynamicDialogModule, DialogService } from 'primeng/dynamicdialog';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { SplitButtonModule } from 'primeng/splitbutton';
import { InputNumberModule } from 'primeng/inputnumber';
import { MultiSelectModule } from 'primeng/multiselect';
import { FileUploadModule } from 'primeng/fileupload';
import { InputTextModule } from 'primeng/inputtext';
import { CheckboxModule } from 'primeng/checkbox';
import { DropdownModule } from 'primeng/dropdown';
import { StepperModule } from 'primeng/stepper';
import { TooltipModule } from 'primeng/tooltip';
import { TabViewModule } from 'primeng/tabview';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { InputSwitchModule } from 'primeng/inputswitch';
import { TableModule } from "primeng/table";
import { RippleModule } from 'primeng/ripple';

@NgModule({
  declarations: [
    CategoryDetailsComponent,
    ContentDetailsComponent,
    CategoryCreateComponent,
    CategoryListComponent,
    AddElearningComponent,
    TopicDetailsComponent,
    TopicCreateComponent,
    ContentListComponent,
    ElearningComponent,
    TopicListComponent,
    OverviewListComponent,
  ],
  imports: [
    FasServicesUploadComponent,
    FasServiceTableComponent,
    DynamicDialogModule,
    InputTextareaModule,
    ReactiveFormsModule,
    InputSwitchModule,
    SplitButtonModule,
    InputNumberModule,
    MultiSelectModule,
    FileUploadModule,
    InputTextModule,
    DropdownModule,
    CheckboxModule,
    TooltipModule,
    StepperModule,
    TooltipModule,
    TabViewModule,
    CommonModule,
    ButtonModule,
    DialogModule,
    FormsModule,
    TableModule,
    RippleModule
],
  providers: [
    DialogService
  ]
})
export class ElearningModule { }
